// import type {Summaries} from '@/types/project';
export const parseSummaries = (summary, type = 'txt') => {
    switch (type) {
        case 'txt':
            return summaryToTxt(summary);
        case 'html':
        case 'pdf':
            return summaryToHtml(summary);
    }
};
/**
 * Converts a list of summary to a text string. It also removes unneeded new line and let the parser handle it.
 * @param summary - The list of summary to convert
 * @returns A text string containing the summary
 */
function summaryToTxt(sermonSummary) {
    let text = '';
    for (const key in sermonSummary) {
        if (sermonSummary.hasOwnProperty(key)) {
            let title = key || '';
            let content = sermonSummary[key] || '';
            text += `${title}\n\n${content}\n\n\n`;
        }
    }
    return text;
}
/**
 * Converts a list of summary to an HTML string.
 * @param summary - The list of summary to convert
 * @returns An HTML string containing the summary
 */
const summaryToHtml = (sermonSummary) => {
    let text = '';
    for (const key in sermonSummary) {
        if (sermonSummary.hasOwnProperty(key)) {
            let title = key || '';
            let content = sermonSummary[key] || '';
            text += `<h1>${title}</h1>
		
		${content}
		`;
        }
    }
    console.log(text);
    return text;
};
